import React, { useState, useEffect } from "react";

/**
 * YouLaber 安装包邀请入口
 *
 * 提供 3 个导出：
 *   - InstallInviteBanner：L1 顶部首次提示条（可关闭，记 localStorage）
 *   - InstallInviteCard：L1 卡片网格末位永久卡片
 *   - InstallInstructionModal：4 步图文 + 下载按钮
 *
 * 下载地址固定指向生产 nginx：见 deploy/nginx_youlaber_download.snippet
 */

const DOWNLOAD_URL =
  "https://baigongai.cn/download/youlaber/YouLaber-Setup-latest.zip";
const ZIP_SIZE_TEXT = "≈ 10 MB";
const DISMISS_KEY = "youlaber_invite_banner_dismissed_v1";

export const InstallInviteBanner = ({ onOpenGuide }) => {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(DISMISS_KEY) === "1");
    } catch (_) {
      setDismissed(false);
    }
  }, []);

  if (dismissed) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch (_) {}
    setDismissed(true);
  };

  return (
    <div
      style={{
        marginTop: "16px",
        padding: "12px 16px",
        borderRadius: "10px",
        background:
          "linear-gradient(95deg, rgba(163,113,247,0.18), rgba(63,185,80,0.14))",
        border: "1px solid rgba(163,113,247,0.4)",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        fontSize: "13px",
        color: "#e6edf3",
      }}
    >
      <span style={{ fontSize: "20px" }}>🚀</span>
      <span style={{ flex: 1, lineHeight: 1.5 }}>
        想把自己的电脑也变成一台 YouLabber 实验员？
        <span style={{ color: "#8b949e", marginLeft: 6 }}>
          5 分钟，安装包仅 {ZIP_SIZE_TEXT}。
        </span>
      </span>
      <button
        onClick={onOpenGuide}
        style={{
          background: "rgba(163,113,247,0.85)",
          border: "none",
          color: "#fff",
          padding: "6px 14px",
          borderRadius: "6px",
          fontSize: "12px",
          fontWeight: 600,
          cursor: "pointer",
          fontFamily: "inherit",
        }}
      >
        查看安装指南
      </button>
      <button
        onClick={dismiss}
        title="不再提示"
        style={{
          background: "transparent",
          border: "none",
          color: "#8b949e",
          fontSize: "16px",
          cursor: "pointer",
          padding: "0 4px",
          fontFamily: "inherit",
        }}
      >
        ×
      </button>
    </div>
  );
};

export const InstallInviteCard = ({ onClick }) => {
  const accent = "#a371f7";
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        all: "unset",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        padding: "20px",
        borderRadius: "14px",
        background:
          "linear-gradient(160deg, rgba(163,113,247,0.18) 0%, rgba(63,185,80,0.10) 60%, rgba(13,17,23,0.92) 100%)",
        border: `1px dashed ${accent}66`,
        boxShadow:
          "0 1px 0 rgba(255,255,255,0.04) inset, 0 8px 24px rgba(0,0,0,0.35)",
        transition: "transform 0.15s ease, border-color 0.15s ease",
        position: "relative",
        overflow: "hidden",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.borderColor = accent;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.borderColor = `${accent}66`;
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "12px",
            background: `${accent}25`,
            color: accent,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "26px",
            border: `1px solid ${accent}55`,
          }}
        >
          🚀
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              color: "#e6edf3",
              fontSize: "16px",
              fontWeight: 600,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            把这台电脑接入邮百工
          </div>
          <div style={{ color: accent, fontSize: "11px", marginTop: "2px" }}>
            让同学和老师远程使用这台电脑连接的实验设备
          </div>
        </div>
      </div>
      <div style={{ color: "#8b949e", fontSize: "12px", lineHeight: 1.6 }}>
        下载安装包，把这台电脑上的实验设备接入邮百工，供同学和老师远程使用。
      </div>
      <div
        style={{
          color: accent,
          fontSize: "12px",
          fontWeight: 600,
          marginTop: "auto",
        }}
      >
        安装共享实验员 →
      </div>
    </button>
  );
};

export const InstallInstructionModal = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.65)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: "560px",
          maxHeight: "88vh",
          overflow: "auto",
          background: "#0d1117",
          border: "1px solid rgba(163,113,247,0.4)",
          borderRadius: "14px",
          padding: "24px 26px",
          color: "#e6edf3",
          boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "6px",
          }}
        >
          <span style={{ fontSize: "22px" }}>🚀</span>
          <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700 }}>
            把这台电脑变成 YouLabber 实验员
          </h3>
        </div>
        <p
          style={{
            margin: "0 0 16px",
            color: "#8b949e",
            fontSize: "12px",
            lineHeight: 1.6,
          }}
        >
          每位实验员都是一台运行 YouLabber 的真实电脑，你可以自己部署一台、
          供同学/老师远程协作。安装包仅 {ZIP_SIZE_TEXT}。
        </p>

        <a
          href={DOWNLOAD_URL}
          target="_blank"
          rel="noreferrer noopener"
          style={{
            display: "block",
            textDecoration: "none",
            textAlign: "center",
            background:
              "linear-gradient(95deg, #a371f7, #6e40c9)",
            color: "#fff",
            padding: "12px 16px",
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "14px",
            marginBottom: "18px",
            boxShadow: "0 4px 14px rgba(163,113,247,0.35)",
          }}
        >
          ⬇ 下载安装包（{ZIP_SIZE_TEXT}）
        </a>

        <div style={{ fontSize: "13px", lineHeight: 1.7 }}>
          <Step n={1} title="解压">
            把下载的 zip 解压到一个固定文件夹（建议 <code>D:\YouLabber</code>），
            <strong>不要</strong>放在"下载"或"桌面"目录。
          </Step>
          <Step n={2} title="双击 YouLabber.exe">
            首次启动会弹 UAC 提权窗口 → 点"是"。
            然后回答 <strong>4 个问题</strong>：设备名 / 访问密码 /
            实验室编号 / 实验员类型。
          </Step>
          <Step n={3} title="完成">
            程序自动开机自启，并通过反向隧道连回邮百工服务器，无需额外组网。
            回到本页面刷新，就能在实验员清单里看到自己。
            想改配置：双击 <code>reconfig.cmd</code>；想卸载：双击{" "}
            <code>uninstall.cmd</code>。
          </Step>
        </div>

        <div
          style={{
            marginTop: "16px",
            padding: "10px 12px",
            background: "rgba(255,255,255,0.03)",
            border: "1px solid rgba(255,255,255,0.06)",
            borderRadius: "8px",
            fontSize: "11px",
            color: "#8b949e",
            lineHeight: 1.6,
          }}
        >
          ⚠ 遇到问题先看包内 <code>使用说明.txt</code>；常见的"双击没反应"
          是 UAC 弹窗被压在任务栏后面。
        </div>

        <div
          style={{
            marginTop: "16px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: "1px solid rgba(255,255,255,0.15)",
              color: "#9aa4b2",
              padding: "6px 14px",
              borderRadius: "6px",
              fontSize: "12px",
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
};

const Step = ({ n, title, children }) => (
  <div style={{ display: "flex", gap: "12px", marginBottom: "10px" }}>
    <div
      style={{
        width: "22px",
        height: "22px",
        flexShrink: 0,
        borderRadius: "50%",
        background: "rgba(163,113,247,0.25)",
        color: "#a371f7",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: 700,
        marginTop: "1px",
      }}
    >
      {n}
    </div>
    <div style={{ flex: 1 }}>
      <div style={{ color: "#e6edf3", fontWeight: 600, marginBottom: "2px" }}>
        {title}
      </div>
      <div style={{ color: "#8b949e" }}>{children}</div>
    </div>
  </div>
);
